import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import GameDetail from "./GameDetail";

const GameDetails = () => {
  return (
    <div>
      <Navbar />
      <GameDetail />
      <Footer />
    </div>
  );
};

export default GameDetails;
